import { Box, Typography, Grid, Stack, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FileListCard from './FileListCard';

const FileList = (props) => {
    const { selectedFiles, selectedFileId, setSelectedFileId, limit, onDelete } = props;
    const { t } = useTranslation();

    const scrollbarStyles = {
        '&::-webkit-scrollbar': {
            width: '0.4em',
            height: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent'
        }
    };

    const handleDeleteFile = (props) => {
        if (onDelete && typeof onDelete === 'function') onDelete(props);
    };

    const handleSelectFile = (id) => {
        if (setSelectedFileId && typeof setSelectedFileId === 'function') setSelectedFileId(id);
    };

    return (
        <Box sx={{ py: 1, px: 2, minHeight: '57vh', width: '100%', borderRadius: 4, overflow: 'hidden' }}>
            <Grid container spacing={1} alignItems="flex-start">
                <Grid container item xs={12} justifyContent="center">
                    <Typography variant="body1">{t('SelectedFiles')}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                    <Typography variant="h4" color={selectedFiles.length === limit ? '#c42c0e' : 'textSecondary'}>
                        {selectedFiles ? selectedFiles.length : '0'} {limit && '/ '}
                        {limit} {selectedFiles.length === 1 ? t('File') : t('Files')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ maxHeight: '59vh', overflowY: 'auto', ...scrollbarStyles }}>
                        <Stack spacing={1} mt={2} mx={2}>
                            {selectedFiles &&
                                selectedFiles.length > 0 &&
                                selectedFiles.map((file, index) => (
                                    <FileListCard
                                        key={index}
                                        file={file}
                                        handleDeleteFile={handleDeleteFile}
                                        selected={selectedFileId === file?.id}
                                        onSelect={handleSelectFile}
                                    />
                                ))}
                        </Stack>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FileList;
